/**
 * Attaky Header - Dropdown & Mobile Menu Interactions
 */
(function() {
  'use strict';

  // All dropdown toggles
  var dropdowns = document.querySelectorAll('.dropdown');
  dropdowns.forEach(function(dropdown) {
    var trigger = dropdown.querySelector('.dropdown__trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = dropdown.getAttribute('data-open') === 'true';

      // Close all other dropdowns first
      dropdowns.forEach(function(d) {
        if (d !== dropdown) {
          d.setAttribute('data-open', 'false');
          var t = d.querySelector('.dropdown__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });

      dropdown.setAttribute('data-open', isOpen ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

  // Close all dropdowns on outside click
  document.addEventListener('click', function(e) {
    dropdowns.forEach(function(dropdown) {
      if (!dropdown.contains(e.target)) {
        dropdown.setAttribute('data-open', 'false');
        var trigger = dropdown.querySelector('.dropdown__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // Close all dropdowns on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      dropdowns.forEach(function(dropdown) {
        dropdown.setAttribute('data-open', 'false');
        var trigger = dropdown.querySelector('.dropdown__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Mobile menu toggle
  var mobileToggle = document.getElementById('mobile-menu-toggle');
  var mobileMenu = document.getElementById('mobile-menu');
  if (mobileToggle && mobileMenu) {
    var iconMenu = mobileToggle.querySelector('.icon-menu');
    var iconClose = mobileToggle.querySelector('.icon-close');

    mobileToggle.addEventListener('click', function() {
      var isOpen = mobileMenu.style.display !== 'none';
      mobileMenu.style.display = isOpen ? 'none' : 'block';
      mobileToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (iconMenu) iconMenu.style.display = isOpen ? 'block' : 'none';
      if (iconClose) iconClose.style.display = isOpen ? 'none' : 'block';
    });

    // Close mobile menu on link click
    var mobileLinks = mobileMenu.querySelectorAll('a');
    mobileLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        mobileMenu.style.display = 'none';
        mobileToggle.setAttribute('aria-expanded', 'false');
        if (iconMenu) iconMenu.style.display = 'block';
        if (iconClose) iconClose.style.display = 'none';
      });
    });
  }
})();
